import script from "./NewsSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsSingle.vue?vue&type=script&setup=true&lang=js"

import "./NewsSingle.vue?vue&type=style&index=0&id=01e5fbc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e5fbc2"]])

export default __exports__